module.exports = __webpack_public_path__ + "static/media/Logo__Twitter.5251e56e.svg";